<template>
  <div class="Capitalaccount">
    <div class="Capitalaccount_money">
      <p class="Capitalaccount_money_text">余额(元)</p>
      <p class="Capitalaccount_money_num">￥{{ account || '0.00' }}</p>
    </div>
    <FooterTwoButton
      :leftNext="leftNext"
      :rightNext="rightNext"
      right="转入"
      left="转出"
    ></FooterTwoButton>
    <div class="list list_margin">
      <List class="List_style" left="||类电子账户">
        <div class="List_copy">
          <div>{{ cardNum }}</div>
          <div class="List_copy_btn" @click="onSee">
           查看
          </div>
        </div>
      </List>
    </div>
    <div class="list">
      <List left="开户银行" right="浦发银行" />
    </div>
    <div class="list list_margin" @click="goBindCardManage()">
      <List left="账户绑卡管理">
        <i class="iconfont icon-you icon_account"></i>
      </List>
    </div>
    <div class="list" @click="goTransactionRecord()">
      <List left="账户交易记录">
        <i class="iconfont icon-you icon_account"></i>
      </List>
    </div>

    <div class="loadingBox" v-if="IsloadingBox">
      <Loading accountFont="加载中..." color="#fff" type="spinner"></Loading>
    </div>
    <div class="returnBtnBox" @click="goToNextPage">
      <div class="btn">返回</div>
    </div>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import FooterTwoButton from '@/components/FooterTwoButton.vue';
import { milliFormat } from '@/utils';
import { mapState, mapMutations } from 'vuex';
import Loading from '@/components/Loading.vue';
import { Toast } from 'vant';

export default {
  name: 'Capitalaccount',
  data() {
    return {
      account: 0.0,
      cardNum: '',
      // 弹窗
      ShowContent: '',
      IsloadingBox: false,
    };
  },
  components: {
    List,
    FooterTwoButton,
    Loading,
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    onSee() {
      this.$api.PublicPage.getSuccessfulLink({
        orderId: this.capitalAccount.orderId,
      }).then((res) => {
        if (res.success) {
          window.location.href = res.data.successful_link;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    getBalance() {
      this.IsloadingBox = true;
      this.$api.CommonForms.getBalance({
        orderId: this.capitalAccount.orderId,
      })
        .then((res) => {
          if (res.success) {
            // eslint-disable-next-line camelcase
            const { account_balance, card_num } = res.data;
            this.account = milliFormat(account_balance);
            // eslint-disable-next-line camelcase
            this.cardNum = card_num;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
          this.IsloadingBox = false;
        })
        .catch(() => {
          this.$dialog.alert({
            title: '提示',
            message: '网络异常，请稍后再试！',
          });
          this.IsloadingBox = false;
        });
    },
    leftNext() {
      this.$router.push('/supermarket/v2/OutAmount');
    },
    rightNext() {
      this.$router.push('/supermarket/v2/EnterAmount');
    },
    // 去交易记录页面
    goTransactionRecord() {
      this.$router.push('/supermarket/v2/TransactionRecord');
    },
    // 去绑卡管理页面
    goBindCardManage() {
      this.$router.push('/supermarket/v2/BindCardManage');
    },
    goToNextPage() {
      this.$router.push('/supermarket/v2/myload');
      // this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.Capitalaccount {
  padding-top: 16px;
}
.returnBtnBox {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 16px;
}
.btn {
  width: 100%;
  height: 40px;
  /* background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%); */
  border: 1px solid #f65249;
  border-radius: 4px;
  /* color: #fff; */
  color: #f65249;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.Capitalaccount_money {
  width: 90%;
  margin: 0 auto;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 8px;
  text-align: left;
  padding: 24px 0;
}
.Capitalaccount_money_text {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #ffffff;
  margin: 0;
  margin: 0 0 12px 12px;
}
.Capitalaccount_money_num {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #ffffff;
  margin: 0;
  margin-left: 12px;
}
.list_margin {
  margin-top: 16px;
}
.List_style {
  border-bottom: 1px solid#DDDEE1;
}
.List_copy {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #495060;
}
.List_copy_btn {
  margin-left: 8px;
  color: #f65846;
}
.list {
  background: #fff;
}
.icon_account {
  font-size: 20px;
  color: #80848f;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
